import { toaster } from '#features/ui/components/Toaster';
import {
  isAbortedRequest,
  isNetworkFailure,
  NETWORK_TOAST_ID,
  resolveErrorText,
} from './errorText';
import { openErrorToastGate } from './errorToastGate';
import { markErrorShownToUser, wasErrorShownToUser } from './shownErrors';

/**
 * Сказать человеку, что действие не удалось, - один раз.
 *
 * Зовёт общий обработчик мутаций, и зовёт любой `catch` у действия, которое идёт мимо
 * `useMutation` (прямой вызов `gqlFetcher`): общего обработчика там нет, и без вызова отказ
 * молчал бы. Повторный вызов с той же ошибкой ничего не показывает.
 */
export const reportActionError = (error: unknown) => {
  if (wasErrorShownToUser(error) || isAbortedRequest(error)) {
    return;
  }

  toaster.create({
    ...(isNetworkFailure(error) ? { id: NETWORK_TOAST_ID } : {}),
    title: resolveErrorText(error),
    type: 'error',
  });
  openErrorToastGate();
  markErrorShownToUser(error);
};
